const rootArea = "/invoices";

export const invoicesGlob = (baseArea: string) => ({
	self: `${baseArea}${rootArea}`,
	read: `${baseArea}${rootArea}/read`, 			
	edit: `${baseArea}${rootArea}/edit`
});